export default function RefineSkeleton() {
  return (
    <div className="py-4 px-2 w-full max-w-lg mx-auto animate-pulse space-y-6">
      

      <div className="flex justify-between items-center mb-4">
        <div className="h-5 w-28 bg-gray-300 rounded" />
       
      </div>
      <div className="flex items-center gap-2 px-2 py-1 bg-blue-100 text-xs font-semibold rounded-full shadow-sm mb-2">
        <div className="w-4 h-4 bg-blue-300 rounded-full" />
        <div className="h-4 w-2/3 bg-blue-200 rounded" />
      </div>

      {["Capitalization", "Structure", "Length", "Word Count", "Language"].map((_, i) => (
        <div className="flex justify-between items-center" key={i}>
          <div className="h-4 w-1/3 bg-gray-300 rounded" />
          <div className="h-9 w-1/2 bg-gray-200 rounded" />
        </div>
      ))}

      <div className="relative w-full mt-4">
        <div className="h-12 w-full bg-blue-300 rounded-lg" />
        <div className="absolute top-0 right-0 h-6 w-20 bg-gray-400 rounded-tr-lg rounded-bl-lg" />
      </div>

      <div className="space-y-2 mt-2 text-sm text-gray-700">
        <div className="flex justify-between items-center">
          <div className="h-4 w-1/2 bg-gray-300 rounded" />
          <div className="h-6 w-[35%] bg-blue-400 rounded" />
        </div>
        <div className="h-3 w-24 bg-blue-300 rounded" />
      </div>

      <div className="mt-4 space-y-2">
        <div className="flex justify-between items-center">
          <div className="h-4 w-1/3 bg-gray-300 rounded" />
          <div className="h-4 w-12 bg-blue-300 rounded" />
        </div>
        <div className="border border-gray-400 p-3 rounded bg-gray-100 h-40" />
      </div>
    </div>
  );
}
